import React from 'react'

export default function Header() {
    return (
        <nav className="header navbar pt-3">
            <div className="container-fluid">
                <a className="navbar-brand ms-5" href="/">
                    <img className="img-fluid ms-md-5" alt="" src="/assets/meiuca.svg" />
                </a>
            </div>
        </nav>
    )
}
